module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/art-map-large-f3f52f9ae682c07036a6289e8de7a658.png";